import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-white/40"
        data-testid="protected-loading"
      >
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
}
